module.exports = __webpack_public_path__ + "static/img/image_j_tropical.02c9d97.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_tropical.jpg
// module id = lc6p
// module chunks = 1